import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultQuickNavigatorDisplayText = {
    headingLabel: 'Quick navigator',
    actionButtonLabel: 'Search',
    resetButtonLabel: 'Reset',
    failedToLoadSitesErrorMessage: 'Failed to load cinemas',
    failedToLoadFilmsErrorMessage: 'Failed to load films',
    failedToLoadScreeningDatesErrorMessage: 'Failed to load screening dates',
    failedToLoadShowtimesErrorMessage: 'Failed to load showtimes',
    siteDropdownLabel: 'Cinema',
    siteDropdownPlaceholder: 'Select a cinema',
    siteModalHeading: 'Select a cinema',
    siteModalSearchInputPlaceholder: 'Search cinemas',
    failedToLoadSitesModalErrorTitle: 'Oops, something went wrong!',
    failedToLoadSitesModalErrorMessage: 'Refresh your browser to try loading cinemas again',
    filmDropdownLabel: 'Movies',
    filmDropdownPlaceholder: 'Select a movie',
    filmModalHeading: 'Select a movie',
    filmModalSearchInputPlaceholder: 'Search movies',
    failedToLoadFilmsModalErrorTitle: 'Oops, something went wrong!',
    failedToLoadFilmsModalErrorMessage: 'Refresh your browser to try loading films again',
    noFilmsModalErrorTitle: 'Oops, nothing here!',
    noFilmsModalErrorMessage: 'There are no films currently showing',
    noFilmsForSiteModalErrorTitle: 'Oops, nothing here!',
    noFilmsForSiteModalErrorMessage: 'There are no films currently showing, please choose another cinema',
    screeningDateDropdownLabel: 'Date',
    screeningDateDropdownPlaceholder: 'Select a date',
    screeningDateModalHeading: 'Select a date',
    screeningDateModalSearchInputPlaceholder: 'Search dates',
    failedToLoadScreeningDatesModalErrorTitle: 'Oops, something went wrong!',
    failedToLoadScreeningDatesModalErrorMessage: 'Refresh your browser to try loading dates again',
    noScreeningDatesModalErrorTitle: 'Oops, nothing here!',
    noScreeningDatesModalErrorMessage: 'This film is not currently showing at your selected cinema. Please select another cinema or film.',
    showtimeDropdownLabel: 'Time',
    showtimeDropdownPlaceholder: 'Select a time',
    showtimeModalHeading: 'Select a time',
    showtimeModalSearchInputPlaceholder: 'Search times',
    failedToLoadShowtimesModalErrorTitle: 'Oops, something went wrong!',
    failedToLoadShowtimesModalErrorMessage: 'Refresh your browser to try loading times again',
    noSitesFoundErrorMessage: 'No cinemas found',
    noFilmsFoundErrorMessage: 'No films found',
    noScreeningDatesFoundErrorMessage: 'No screening dates found',
    noShowtimesFoundErrorMessage: 'No showtimes found',
    noSiteSearchResultsFoundModalMessage: 'Sorry, we couldn\'t find any cinemas matching "${searchTerm}".',
    noFilmSearchResultsFoundModalMessage: 'Sorry, we couldn\'t find any films matching "${searchTerm}".',
    noScreeningDateSearchResultsFoundModalMessage: 'Sorry, we couldn\'t find any dates matching "${searchTerm}".',
    noShowtimeSearchResultsFoundModalMessage: 'Sorry, we couldn\'t find any times matching "${searchTerm}".',
    noSiteOrFilmSelectedErrorMessage: 'Please select a site or a film.',
    screeningDateFormat: '${date|d|ddd D MMMM}',
    showtimeFormat: 'h:mm A',
    todayLabel: [' - ', { text: 'Today', className: 'v-screening-date-dropdown-option__today-label' }]
};
export const quickNavigatorDisplayTextValidator = Validator.object({
    headingLabel: nonEmptyStringValidator,
    actionButtonLabel: nonEmptyStringValidator,
    resetButtonLabel: nonEmptyStringValidator,
    failedToLoadSitesErrorMessage: nonEmptyStringValidator,
    failedToLoadFilmsErrorMessage: nonEmptyStringValidator,
    failedToLoadScreeningDatesErrorMessage: nonEmptyStringValidator,
    failedToLoadShowtimesErrorMessage: nonEmptyStringValidator,
    siteDropdownLabel: nonEmptyStringValidator,
    siteDropdownPlaceholder: nonEmptyStringValidator,
    siteModalHeading: nonEmptyStringValidator,
    siteModalSearchInputPlaceholder: nonEmptyStringValidator,
    failedToLoadSitesModalErrorTitle: nonEmptyStringValidator,
    failedToLoadSitesModalErrorMessage: nonEmptyStringValidator,
    filmDropdownLabel: nonEmptyStringValidator,
    filmDropdownPlaceholder: nonEmptyStringValidator,
    filmModalHeading: nonEmptyStringValidator,
    filmModalSearchInputPlaceholder: nonEmptyStringValidator,
    failedToLoadFilmsModalErrorTitle: nonEmptyStringValidator,
    failedToLoadFilmsModalErrorMessage: nonEmptyStringValidator,
    noFilmsModalErrorTitle: nonEmptyStringValidator,
    noFilmsModalErrorMessage: nonEmptyStringValidator,
    noFilmsForSiteModalErrorTitle: nonEmptyStringValidator,
    noFilmsForSiteModalErrorMessage: nonEmptyStringValidator,
    screeningDateDropdownLabel: nonEmptyStringValidator,
    screeningDateDropdownPlaceholder: nonEmptyStringValidator,
    screeningDateModalHeading: nonEmptyStringValidator,
    screeningDateModalSearchInputPlaceholder: nonEmptyStringValidator,
    failedToLoadScreeningDatesModalErrorTitle: nonEmptyStringValidator,
    failedToLoadScreeningDatesModalErrorMessage: nonEmptyStringValidator,
    noScreeningDatesModalErrorTitle: nonEmptyStringValidator,
    noScreeningDatesModalErrorMessage: nonEmptyStringValidator,
    showtimeDropdownLabel: nonEmptyStringValidator,
    showtimeDropdownPlaceholder: nonEmptyStringValidator,
    showtimeModalHeading: nonEmptyStringValidator,
    showtimeModalSearchInputPlaceholder: nonEmptyStringValidator,
    failedToLoadShowtimesModalErrorTitle: nonEmptyStringValidator,
    failedToLoadShowtimesModalErrorMessage: nonEmptyStringValidator,
    noSitesFoundErrorMessage: nonEmptyStringValidator,
    noFilmsFoundErrorMessage: nonEmptyStringValidator,
    noScreeningDatesFoundErrorMessage: nonEmptyStringValidator,
    noShowtimesFoundErrorMessage: nonEmptyStringValidator,
    noSiteSearchResultsFoundModalMessage: nonEmptyStringValidator,
    noFilmSearchResultsFoundModalMessage: nonEmptyStringValidator,
    noScreeningDateSearchResultsFoundModalMessage: nonEmptyStringValidator,
    noShowtimeSearchResultsFoundModalMessage: nonEmptyStringValidator,
    noSiteOrFilmSelectedErrorMessage: nonEmptyStringValidator,
    screeningDateFormat: nonEmptyStringValidator,
    showtimeFormat: nonEmptyStringValidator,
    todayLabel: displayTextLabelValidator
});
